import React from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaWhatsapp } from 'react-icons/fa';

export default function ContactPage() {
  return (
    <>
      <section className="text-center py-12 bg-white">
        <h1 className="text-4xl md:text-5xl font-bold text-[var(--color-primary)] mb-4">İletişim</h1>
        <p className="text-lg md:text-xl text-[var(--color-black)] max-w-2xl mx-auto mb-8">
          Bizimle iletişime geçmek için aşağıdaki kanalları kullanabilirsiniz.
        </p>
      </section>

      <section className="py-12 bg-[var(--color-background)]">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12">
            {/* İletişim Bilgileri */}
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <h2 className="text-2xl font-bold text-[var(--color-primary)] mb-6">İletişim Bilgileri</h2>
              <div className="space-y-6">
                <div className="flex items-center gap-4">
                  <FaPhone className="text-2xl text-[var(--color-secondary)]" />
                  <div>
                    <h3 className="font-semibold">Telefon</h3>
                    <p>+90 530 313 41 65</p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <FaEnvelope className="text-2xl text-[var(--color-secondary)]" />
                  <div>
                    <h3 className="font-semibold">E-posta</h3>
                    <p>info@solartools.com.tr</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <FaMapMarkerAlt className="text-2xl text-[var(--color-secondary)] mt-1" />
                  <div>
                    <h3 className="font-semibold">Merkez</h3>
                    <p className="text-[var(--color-black)]">
                      Çukurova Teknokent<br />
                      Balcalı Mahallesi Güney Kampüs/5 Sk. No:4/1<br />
                      İç Kapı No:17 Sarıçam / Adana
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <FaMapMarkerAlt className="text-2xl text-[var(--color-secondary)] mt-1" />
                  <div>
                    <h3 className="font-semibold">Şube</h3>
                    <p className="text-[var(--color-black)]">
                      Atölye<br />
                      Yeşiloba Mah. 46290 Sok No 4S<br />
                      Seyhan/Adana
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* İletişim Formu */}
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <h2 className="text-2xl font-bold text-[var(--color-primary)] mb-6">Bize Ulaşın</h2>
              <form className="space-y-4">
                <div>
                  <input 
                    type="text" 
                    placeholder="Adınız Soyadınız" 
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--color-primary)] focus:border-transparent"
                  />
                </div>
                <div>
                  <input 
                    type="email" 
                    placeholder="E-posta Adresiniz" 
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--color-primary)] focus:border-transparent"
                  />
                </div>
                <div>
                  <textarea 
                    rows="4" 
                    placeholder="Mesajınız" 
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--color-primary)] focus:border-transparent"
                  ></textarea>
                </div>
                <button 
                  type="submit" 
                  className="w-full bg-[var(--color-primary)] hover:bg-[var(--color-secondary)] text-white font-semibold py-3 rounded-lg transition-colors duration-300"
                >
                  Gönder
                </button>
              </form>
            </div>
          </div>

          {/* Haritalar */}
          <div className="grid md:grid-cols-2 gap-12 mt-12">
            {/* Merkez Haritası */}
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <h2 className="text-2xl font-bold text-[var(--color-primary)] mb-6">Merkez Konum</h2>
              <div className="aspect-video rounded-lg overflow-hidden">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1598.5823899263212!2d35.35279687619167!3d36.99829905806913!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15288f64fdf4aa27%3A0x5dd3d80819c6a4a9!2s%C3%87ukurova%20Teknokent!5e0!3m2!1str!2str!4v1710271144400!5m2!1str!2str&z=17"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
              <div className="mt-4">
                <h3 className="font-semibold text-lg mb-2">Çukurova Teknokent</h3>
                <p className="text-sm text-gray-600">
                  Balcalı Balcalı Mah. Güney Kampüs Bulv. Teknokent Sitesi Yönetim ve Kuluçka Merkezi, Balcalı, Güney Kampüs Yolu Teknokent Sitesi, 01330 Sarıçam/Adana
                </p>
                <div className="flex items-center gap-2 mt-2">
                  <div className="flex items-center">
                    <span className="text-[var(--color-secondary)] font-semibold">4.3</span>
                    <div className="flex text-yellow-400 ml-1">
                      {"★".repeat(4)}
                      {"☆".repeat(1)}
                    </div>
                  </div>
                  <span className="text-sm text-gray-500">(334 yorum)</span>
                </div>
                <a 
                  href="https://maps.google.com/maps/dir//Çukurova+Teknokent" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-block mt-3 text-[var(--color-primary)] hover:text-[var(--color-secondary)] font-semibold"
                >
                  Yol Tarifi
                </a>
              </div>
            </div>

            {/* Şube Haritası */}
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <h2 className="text-2xl font-bold text-[var(--color-primary)] mb-6">Şube Konum</h2>
              <div className="aspect-video rounded-lg overflow-hidden">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d799.1469115005137!2d35.3492661!3d36.9896111!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15288f9e7d0163c5%3A0x5d3f2a35c08d30c8!2sSöylemez+Elektrik+Otomasyon!5e0!3m2!1str!2str!4v1710271144400!5m2!1str!2str&z=18"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
              <div className="mt-4">
                <h3 className="font-semibold text-lg mb-2">Söylemez Elektrik Otomasyon</h3>
                <p className="text-sm text-gray-600">
                  Tekel Caddesi, Yeşiloba, 46290 Sokak No:5, 01100 Seyhan/Adana
                </p>
                <div className="flex items-center gap-2 mt-2">
                  <div className="flex items-center">
                    <span className="text-[var(--color-secondary)] font-semibold">4.3</span>
                    <div className="flex text-yellow-400 ml-1">
                      {"★".repeat(4)}
                      {"☆".repeat(1)}
                    </div>
                  </div>
                  <span className="text-sm text-gray-500">(4 yorum)</span>
                </div>
                <a 
                  href="https://maps.google.com/maps/dir//Söylemez+Elektrik+Otomasyon" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-block mt-3 text-[var(--color-primary)] hover:text-[var(--color-secondary)] font-semibold"
                >
                  Yol Tarifi
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WhatsApp Butonu */}
      <a
        href="https://wa.me/905303134165"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 bg-green-500 text-white p-4 rounded-full shadow-lg hover:bg-green-600 transition-colors"
        aria-label="WhatsApp ile iletişime geç"
      >
        <FaWhatsapp size={24} />
      </a>
    </>
  );
} 